import * as React from 'react';
import type { InjectedIntlProps } from 'react-intl';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { RadioGroup as AkRadioGroup } from '@atlaskit/radio';
import { token } from '@atlaskit/tokens';
import { FieldBase } from '@atlassian/help-center-common-component/fields/field-base';
import type { FieldFormProps } from '@atlassian/help-center-common-component/fields/types';
import i18n from './messages';

export interface Item {
    label: string;
    name: string;
    value: string;
}

export interface Props extends FieldFormProps<string> {
    items?: Item[];
    defaultValue?: string;
}

const NONE_OPTION_VALUE = '-1';

class RadioGroup extends React.PureComponent<Props & InjectedIntlProps> {
    onChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        if (this.props.onChange) {
            this.props.onChange(this.props.id, e.target.value);
        }
    };

    render() {
        const { required, label, id, description, defaultValue, errorMessage, disabled, intl, items = [] } = this.props;

        const radioItems = items.map((item) => {
            return {
                label: item.label,
                name: item.name,
                value: item.value,
                isDisabled: disabled,
            };
        });

        if (!required) {
            radioItems.push({
                label: intl.formatMessage(i18n.noneOptionLabel),
                name: id,
                value: NONE_OPTION_VALUE,
                isDisabled: disabled,
            });
        }

        return (
            <FieldBase
                htmlFor={id}
                noLabel={false}
                required={required}
                description={description}
                label={label}
                errorMessage={errorMessage}
            >
                <RadioGroupWrapper>
                    <AkRadioGroup
                        isRequired={required}
                        options={radioItems}
                        onChange={this.onChange}
                        defaultValue={defaultValue}
                    />
                </RadioGroupWrapper>
            </FieldBase>
        );
    }
}

export default injectIntl(RadioGroup);

const RadioGroupWrapper = styled.div`
    padding: ${token('space.075', '6px')};
`;
